import {useContext} from 'react'
import About from '../StaticPages/About/About'
import Helmet from 'react-helmet'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import {  LanguageContext } from '../context';
import AboutEn from '../StaticPages/About/AboutEn'
import MetaTags from '../Components/MetaTags/MetaTags'

const AboutPage = () => {

    const { language } = useContext(LanguageContext);
  return (
    <div>
      <MetaTags title={"About page"} description={"About page"}/>
       
      
      <Header/>
      <div role="main" aria-label="About">
      {
          language=="he"?<About/>: <AboutEn/>
      }
    </div>
      
    
   
        <Footer/>

    </div>
  )
}

export default AboutPage